<div class="inner" [class.connected]="stateSvc.web3Connected$ | async">

  <a [routerLink]="['/']" class="logo" (click)="refresh()">
    <ng-template [ngTemplateOutlet]="logo"></ng-template>
  </a>

  <div class="search-wrapper">
    <app-search *ngIf="searchBarShown$ | async"></app-search>
  </div>

  <div class="user-tools">

    <app-header-icons *ngIf="isDesktop$ | async"></app-header-icons>

    <div class="search-icon">
      <button [class]="themeSvc.theme$ | async" (click)="toggleSearchBar()">
        <ng-template [ngTemplateOutlet]="magnifyingGlass"></ng-template>
      </button>
    </div>

    <div class="connect-menu">
      <ng-container *ngIf="(stateSvc.web3Connected$ | async)">

        <div>
          <a
            *ngIf="(stateSvc.walletAddress$ | async) as address"
            [routerLink]="['/', 'owned']"
            [href]="'/owned'"
            [queryParams]="{ address }">

            <app-wallet-address [address]="address" />
          </a>

          <div
            *ngIf="(totalDelegations$ | async) as totalDelegations; else noDelegations"
            class="delegations"
            tippy
            [options]="{
              interactive: true,
              content: delegationTooltipContent,
              placement: 'bottom'
            }">
            <ng-container *ngIf="{ incomingDelegationsCount: ((incomingDelegationsCount$ | async) ?? 0) } as data">
              <button
                class="delegations-trigger"
                [class.can-swap]="data.incomingDelegationsCount > 0"
                [disabled]="data.incomingDelegationsCount === 0"
                [attr.aria-label]="data.incomingDelegationsCount > 0 ? 'Swap account' : null"
                [attr.title]="data.incomingDelegationsCount > 0 ? 'Swap account' : null"
                (click)="openSignatureExplanationModal(data.incomingDelegationsCount)">
                <span>{{ totalDelegations }} delegation{{ totalDelegations > 1 ? 's' : '' }}</span>
                <svg
                  *ngIf="data.incomingDelegationsCount > 0"
                  class="swap-account-icon"
                  viewBox="0 0 24 24"
                  width="14"
                  height="14"
                  aria-hidden="true">
                  <path
                    d="M7 7h10l-2.5-2.5L16 3l5 5-5 5-1.5-1.5L17 9H7V7zm10 10H7l2.5 2.5L8 21l-5-5 5-5 1.5 1.5L7 15h10v2z"
                    fill="currentColor" />
                </svg>
              </button>
            </ng-container>
          </div>
        </div>
        <ng-template #noDelegations>
          <div class="delegations" tippy
              [options]="{
                interactive: true,
                content: delegationTooltipContent,
                placement: 'bottom'
              }">
            No delegation
          </div>
        </ng-template>        
      </ng-container>

      <div class="withdraw-actions">
        <button
          *ngIf="(stateSvc.hasWithdrawal$ | async) as withdrawal;"
          (click)="web3Svc.withdraw()"
          class="withdraw">

          <ng-template [ngTemplateOutlet]="withdrawIcon" />
          Withdraw (legacy Ξ{{ withdrawal }})
        </button>

        <button
          *ngIf="(stateSvc.web3Connected$ | async) && environment.featureFlags?.STASH_BID_SUPPORT !== false && hasStashWithdrawal"
          (click)="openStashWithdrawal()"
          class="withdraw withdraw-stash">

          <ng-template [ngTemplateOutlet]="withdrawIcon" />
          Stash withdrawal (Ξ{{ stashWithdrawalAmountDisplay }})
        </button>
      </div>

      <button
        *ngIf="!(stateSvc.web3Connected$ | async)"
        class="connect"
        (click)="connect()">
        
        Connect
      </button>

      <button
        *ngIf="(stateSvc.web3Connected$ | async)"
        class="connect"
        (click)="connect()">
        
        Connected
        <ng-container *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false">
          <ng-container *ngIf="(signatureStatus$ | async) as signatureStatus">
          <span
            *ngIf="signatureStatus !== 'disconnected'"
            class="signature-status-indicator"
            [class.unsigned]="signatureStatus === 'unsigned'"
            [class.signed]="signatureStatus === 'signed'"
            [attr.aria-label]="signatureStatus === 'unsigned' ? 'Wallet connected but not signed. Click to sign.' : 'Wallet connected and signed.'"
            tippy
            [options]="{
              content: signatureStatusTooltipContent,
              placement: 'bottom'
            }"
            (click)="$event.stopPropagation(); handleSignatureIndicatorClick(signatureStatus)">
          </span>
          </ng-container>
        </ng-container>
      </button>

      <button
        class="menu-toggle"
        (click)="setMenuState()">
  
        <ng-template [ngTemplateOutlet]="menuIcon" />
      </button>
    </div>
  </div>
</div>

<ng-template #menuIcon>
  <svg height="15" viewBox="0 0 9 15" width="9" xmlns="http://www.w3.org/2000/svg"><path d="m6 6h3v3h-3zm-3-3h3v3h-3zm0 6h3v3h-3zm-3-9h3v3h-3zm0 12h3v3h-3z" fill-rule="evenodd" fill="currentColor" /></svg>
</ng-template>

<ng-template #logo>
    <svg height="60" *ngIf="environment.collection === 'cryptopunks'" viewBox="0 0 767.183594 60" width="767.183594" height="60" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="m210.203125 17h15.609375v5.203125h-15.609375zm-5.203125 5.203125h5.203125v15.609375h-5.203125zm20.8125 0h5.203125v5.203125h-5.203125zm0 10.40625h5.203125v5.203125h-5.203125zm-15.609375 5.203125h15.609375v5.1328125h-15.609375zm25.207031-20.8125h20.8125v5.203125h-15.609375v5.203125h15.609375v5.203125h-15.609375v10.3359375h-5.203125zm20.8125 5.203125h5.203125v5.203125h-5.203125zm0 10.40625h5.203125v10.3359375h-5.203125zm9.597656-15.609375h5.203126v5.203125h-5.203126zm20.8125 0h5.203126v5.203125h-5.203126zm-15.609374 5.203125h5.203124v5.203125h-5.203124zm10.40625 0h5.203124v5.203125h-5.203124zm-5.203126 5.203125h5.203126v15.5390625h-5.203126zm20.003907-10.40625h20.8125v5.203125h-15.609375v5.203125h15.609375v5.203125h-15.609375v10.3359375h-5.203125zm20.8125 5.203125h5.203125v5.203125h-5.203125zm9.597656-5.203125h26.015625v5.203125h-10.40625v20.7421875h-5.203125v-20.7421875h-10.40625zm35.613281 0h15.609375v5.203125h-15.609375zm-5.203125 5.203125h5.203125v15.609375h-5.203125zm20.8125 0h5.203125v15.609375h-5.203125zm-15.609375 15.609375h15.609375v5.1328125h-15.609375zm25.207032-20.8125h20.8125v5.203125h-15.609376v5.203125h15.609376v5.203125h-15.609376v10.3359375h-5.203124zm20.8125 5.203125h5.203124v5.203125h-5.203124zm9.597656-5.203125h5.203125v20.8125h-5.203125zm20.8125 0h5.203125v20.8125h-5.203125zm-15.609375 20.8125h15.609375v5.1328125h-15.609375zm25.207031-20.8125h5.203125v5.203125h5.203125v5.203125h-5.203125v15.5390625h-5.203125zm20.8125 0h5.203125v25.9453125h-5.203125v-5.1328125h-5.203125v-5.203125h5.203125zm-10.40625 10.40625h5.203125v5.203125h-5.203125zm20.003906-10.40625h5.203125v10.40625h10.40625v5.203125h-10.40625v10.3359375h-5.203125zm20.8125 0h5.203125v5.203125h-5.203125zm-5.203125 5.203125h5.203125v5.203125h-5.203125zm0 10.40625h5.203125v5.203125h-5.203125zm5.203125 5.203125h5.203125v5.1328125h-5.203125zm14.800782-20.8125h20.8125v5.203125h-20.8125zm-5.203126 5.203125h5.203126v5.203125h-5.203126zm5.203126 5.203125h15.609374v5.203125h-15.609374zm15.609374 5.203125h5.203126v5.203125h-5.203126zm-20.8125 5.203125h20.8125v5.1328125h-20.8125zm30.410157 0h5.203125v5.1328125h-5.203125zm9.597656-20.8125h26.015625v5.203125h-20.8125v5.203125h15.609375v5.203125h-15.609375v5.203125h20.8125v5.1328125h-26.015625zm30.410156 0h26.015625v5.203125h-10.40625v20.7421875h-5.203125v-20.7421875h-10.40625zm30.410157 0h5.203124v10.40625h15.609376v-10.40625h5.203124v25.9453125h-5.203124v-10.3359375h-15.609376v10.3359375h-5.203124zm30.410156 20.8125h5.203125v5.1328125h-5.203125zm9.597656-20.8125h5.203125v20.8125h20.8125v5.1328125h-26.015625zm30.410156 0h26.015625v5.203125h-10.40625v15.609375h10.40625v5.1328125h-26.015625v-5.1328125h10.40625v-15.609375h-10.40625zm30.410156 0h5.203126v5.203125h5.203124v5.203125h-5.203124v15.5390625h-5.203126zm20.8125 0h5.203126v25.9453125h-5.203126v-15.5390625h-5.203124v-5.203125h5.203124zm-10.40625 10.40625h5.203126v5.203125h-5.203126zm25.207032-10.40625h15.609375v5.203125h-15.609375zm-5.203125 5.203125h5.203125v15.609375h-5.203125zm20.8125 0h5.203125v15.609375h-5.203125zm-15.609375 15.609375h15.609375v5.1328125h-15.609375z" fill="rgba(var(--dark-text), 1)"/><g transform="matrix(-1 0 0 1 165 0)"><path d="m0 60v-60h165v15h-15v15h-15v30zm60-15v-30h-45v30zm60-30h-45v30h45z" fill="rgba(var(--dark-text), 1)"/><path d="m75 45v-30h45v30z" fill="#328dfd"/><path d="m15 45v-30h45v30z" fill="#fd3232"/></g></g></svg>
    <svg *ngIf="environment.collection === 'cryptophunks'" xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 0 1477.3 158.4">
      <defs>
        <style>
          .st0, .st1 {
            fill-rule: evenodd;
          }
    
          .st1 {
            fill: #fc00c2;
          }
        </style>
      </defs>
      <path id="cryptophunks.com" class="st0" d="M156,60.6h44v-15h-44v15ZM142,104.6h14v-44h-14v44ZM200,75.6h15v-15h-15v15ZM200,104.6h15v-14.9s-15,0-15,0v15ZM156,118.6h44v-14h-44v14ZM227,118.6h15v-29h44v-14h-44v-15h44v-15h-59v73ZM286,75.6h15v-15h-15v15ZM286,118.6h15v-29h-15v29ZM312,60.6h15v-15h-15v15ZM372,60.6h15v-15h-15v15ZM327,75.6h15v-15h-15v15ZM357,75.6h15v-15h-15v15ZM342,118.6h15v-43h-15v43ZM398,118.6h15v-29h44v-14h-44v-15h44v-15h-59v73ZM457,75.6h15v-15h-15v15ZM484,60.6h29v58h15v-58h29v-15h-73v15ZM584,60.6h44v-15h-44v15ZM569,104.6h15v-44h-15v44ZM628,104.6h15v-44h-15v44ZM584,118.6h44v-14h-44v14ZM655,118.6h15v-29h44v-14h-44v-15h44v-15h-59v73ZM714,75.6h15v-15h-15v15ZM741,118.6h15v-28h43v28h15V45.6h-15v30h-43v-30h-15v73ZM826,103.6h15v-58h-15v58ZM885,103.6h15v-58h-15v58ZM841,118.6h44v-15h-44v15ZM912,118.6h15v-43h14v-15h-14v-15h-15v73ZM970,90.6h-14v15h14v13h15V45.6h-15v45ZM941,90.6h15v-15h-15v15ZM997,118.6h15v-29h29v-14h-29v-30h-15v73ZM1056,60.6h15v-15h-15v15ZM1041,75.6h15v-15h-15v15ZM1041,103.6h15v-14h-14.9c0,0-.1,14-.1,14ZM1056,118.6h15v-15h-15v15ZM1097,60.6h59v-15h-59v15ZM1082,74.6h15v-14h-15v14ZM1097,89.6h44v-15h-44v15ZM1141,103.6h15v-14h-15v14ZM1082,118.6h59v-15h-59v15ZM1168,118.6h15v-15h-15v15ZM1365,118.6h15v-43h15v-15h-15v-15h-15v73ZM1425,60.6h-15v15h15v43h15V45.6h-15v15ZM1395,90.6h15v-15h-15v15ZM1210,60.6h44v-15h-44v15ZM1196,104.6h14v-44h-14v44ZM1254,75.6h15v-15h-15v15ZM1254,104.6h15v-14.9s-15,0-15,0v15ZM1210,118.6h44v-14h-44v14ZM1295,60.6h44v-15h-44v15ZM1280,104.6h15v-44h-15v44ZM1339,104.6h15v-44h-15v44ZM1295,118.6h44v-14h-44v14Z" fill="rgba(var(--dark-text), 1)" />
      <path id="Circles" class="st1" d="M56,28.6h29v29h-29v-29ZM56,67.6h29v29h-29v-29ZM56,106.6h29v29h-29v-29ZM20,35.6h14v14h-14v-14ZM20,74.6h14v14h-14v-14ZM20,113.6h14v14h-14v-14Z"/>
    </svg>

    <ng-container *ngIf="environment.collection === 'cryptopunks-v1'">
      <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" height="25" version="1.1" viewBox="0 0 242.25 25">
        <!-- Generator: Adobe Illustrator 29.5.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 141)  -->
        <defs>
          <style>
            .st0 {
              fill: #fff;
              fill-rule: evenodd;
            }
      
            .st1 {
              fill: #a69afe;
            }
          </style>
        </defs>
        <g id="Artboard_1">
          <g id="Light">
            <g id="V1_08">
              <rect class="st1" width="29.49" height="25"/>
              <path id="v1" class="st0" d="M6.74,13.62h1.97v-6.18h-1.97v6.18ZM15.03,13.62h1.97v-6.18h-1.97s0,6.18,0,6.18ZM8.71,15.73h2.11v-2.11h-2.11v2.11ZM12.92,15.73h2.11v-2.11h-2.11v2.11ZM10.81,17.7h2.11v-1.97h-2.11v1.97ZM20.79,9.55h-2.11v2.11h2.11v6.04h1.97V7.44h-1.97v2.11h0Z"/>
              <g fill="rgba(var(--dark-text), 1)">
                <path d="M41.34,9.54h2.05v6.14h-2.05s0-6.14,0-6.14ZM43.39,7.49h6.14v2.05h-6.14v-2.05ZM43.39,15.68h6.14v2.02h-6.14s0-2.02,0-2.02ZM49.53,9.54h2.05v2.05h-2.05v-2.05ZM49.53,13.63h2.05v2.05h-2.05v-2.05Z"/>
                <path d="M53.31,7.49h8.19v2.05h-6.14v2.05h6.14v2.05h-6.14v4.07h-2.05V7.49ZM61.5,9.54h2.05v2.05h-2.05v-2.05ZM61.5,13.63h2.05v4.07h-2.05v-4.07Z"/>
                <path d="M65.28,7.49h2.05v2.05h-2.05v-2.05ZM67.33,9.54h2.05v2.05h-2.05v-2.05ZM69.38,11.58h2.05v6.12h-2.05v-6.12ZM71.43,9.54h2.05v2.05h-2.05v-2.05ZM73.48,7.49h2.05v2.05h-2.05v-2.05Z"/>
                <path d="M77.25,7.49h8.19v2.05h-6.14v2.05h6.14v2.05h-6.14v4.07h-2.05V7.49ZM85.44,9.54h2.05v2.05h-2.05v-2.05Z"/>
                <path d="M89.22,7.49h10.24v2.05h-4.09v8.16h-2.05v-8.16h-4.09v-2.05h0Z"/>
                <path d="M101.19,9.54h2.05v6.14h-2.05s0-6.14,0-6.14ZM103.24,7.49h6.14v2.05h-6.14v-2.05ZM103.24,15.68h6.14v2.02h-6.14s0-2.02,0-2.02ZM109.38,9.54h2.05v6.14h-2.05s0-6.14,0-6.14Z"/>
                <path d="M113.16,7.49h8.19v2.05h-6.14v2.05h6.14v2.05h-6.14v4.07h-2.05V7.49ZM121.36,9.54h2.05v2.05h-2.05v-2.05Z"/>
                <path d="M125.13,7.49h2.05v8.19h-2.05V7.49ZM127.18,15.68h6.14v2.02h-6.14s0-2.02,0-2.02ZM133.33,7.49h2.05v8.19h-2.05V7.49Z"/>
                <path d="M137.1,7.49h2.05v2.05h2.05v2.05h-2.05v6.12h-2.05V7.49ZM141.2,11.58h2.05v2.05h-2.05v-2.05ZM145.3,7.49h2.05v10.21h-2.05v-2.02h-2.05v-2.05h2.05s0-6.14,0-6.14Z"/>
                <path d="M149.08,7.49h2.05v4.09h4.09v2.05h-4.09v4.07h-2.05V7.49ZM155.22,9.54h2.05v2.05h-2.05v-2.05ZM155.22,13.63h2.05v2.05h-2.05v-2.05ZM157.27,7.49h2.05v2.05h-2.05v-2.05ZM157.27,15.68h2.05v2.02h-2.05s0-2.02,0-2.02Z"/>
                <path d="M161.04,9.54h2.05v2.05h-2.05v-2.05ZM161.04,15.68h8.19v2.02h-8.19v-2.02h0ZM163.09,7.49h8.19v2.05h-8.19v-2.05ZM163.09,11.58h6.14v2.05h-6.14v-2.05ZM169.24,13.63h2.05v2.05h-2.05v-2.05Z"/>
                <path d="M173.02,15.68h2.05v2.02h-2.05s0-2.02,0-2.02Z"/>
                <path d="M176.79,9.54h2.05v6.14h-2.05s0-6.14,0-6.14ZM178.84,7.49h6.14v2.05h-6.14v-2.05ZM178.84,15.68h6.14v2.02h-6.14s0-2.02,0-2.02ZM184.98,9.54h2.05v2.05h-2.05v-2.05ZM184.98,13.63h2.05v2.05h-2.05v-2.05Z"/>
                <path d="M188.76,9.54h2.05v6.14h-2.05s0-6.14,0-6.14ZM190.81,7.49h6.14v2.05h-6.14v-2.05ZM190.81,15.68h6.14v2.02h-6.14s0-2.02,0-2.02ZM196.96,9.54h2.05v6.14h-2.05s0-6.14,0-6.14Z"/>
                <path d="M200.73,7.49h2.05v2.05h2.05v2.05h-2.05v6.12h-2.05V7.49ZM204.83,11.58h2.05v2.05h-2.05v-2.05ZM208.93,7.49h2.05v10.21h-2.05v-6.12h-2.05v-2.05h2.05v-2.05h0Z"/>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </ng-container>
</ng-template>

<ng-template #magnifyingGlass>
  <svg width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24">
    <path fill="rgba(var(--dark-text), 1)" d="M8.7,13.1h-2.2v-6.5h2.2v6.5ZM8.7,15.3v-2.2h2.2v2.2h6.5v2.2h-6.5v-2.2h-2.2ZM8.7,2.2h2.2v2.2h-2.2v-2.2ZM13.1,0h2.2v2.2h-2.2V0ZM15.3,0h2.2v2.2h-2.2V0ZM17.5,0h2.2v2.2h-2.2V0ZM19.6,2.2h2.2v2.2h-2.2v-2.2ZM21.8,4.4h2.2v2.2h-2.2v-2.2ZM21.8,6.5h2.2v2.2h-2.2v-2.2ZM21.8,10.9h2.2v2.2h-2.2v-2.2ZM19.6,13.1h2.2v2.2h-2.2v-2.2ZM6.5,15.3h2.2v2.2h-2.2v-2.2ZM4.4,17.5h2.2v2.2h-2.2v-2.2ZM2.2,19.6h2.2v2.2h-2.2v-2.2ZM10.9,0h2.2v2.2h-2.2V0ZM17.5,15.3h2.2v2.2h-2.2v-2.2ZM6.5,4.4h2.2v2.2h-2.2v-2.2ZM21.8,8.7h2.2v2.2h-2.2v-2.2ZM0,21.8h2.2v2.2H0v-2.2Z"/>
  </svg>
</ng-template>

<ng-template #withdrawIcon>
  <svg height="6" viewBox="0 0 5 6" width="5" xmlns="http://www.w3.org/2000/svg"><g><path d="m0 0h1v1h-1z" opacity=".6"/><path d="m1 0h1v1h-1z" opacity=".7"/><path d="m2 0h1v1h-1z" opacity=".8"/><path d="m3 0h1v1h-1z" opacity=".7"/><path d="m4 0h1v1h-1z" opacity=".6"/><path d="m2 2h1v1h-1z"/><path d="m2 1h1v1h-1z"/><path d="m2 3h1v1h-1z"/><path d="m2 4h1v1h-1z"/><path d="m3 4h1v1h-1z"/><path d="m2 5h1v1h-1z"/><path d="m4 3h1v1h-1z"/><path d="m1 4h1v1h-1z"/><path d="m0 3h1v1h-1z"/></g></svg>
</ng-template>



